































































import { Component, Vue } from "vue-property-decorator";
import UserApi from "@/api/userApi";
import ResetPasswordExpired from "@/views/pages/resetPasswordExpired.vue";
import ResetPasswordCompleted from "@/views/pages/resetPasswordCompleted.vue";
import QErrors from "@/common/qErrors.vue";

@Component({
  name: "ResetPage",
  components: {
    ResetPasswordExpired,
    ResetPasswordCompleted,
    QErrors,
  },
})
export default class ResetPage extends Vue {
  public form = {
    password: "",
    password_confirmation: "",
  };
  public isExpired = false;
  public isCompleted = false;
  public token: string;
  public username = "";
  public message = "";
  public errors = {};
  public errorStyle = {
    width: "100%",
    marginBottom: "1rem",
    textAlign: "left",
  };

  async mounted() {
    // Get token
    this.token = this.$route.params.token;
    await this.verifyToken();
  }
  private async verifyToken(): Promise<void> {
    try {
      // Call api verify token
      const response = await UserApi.verifyToken(this.token);
      if (response.meta.status !== 200) {
        this.isExpired = true;
      }
    } catch (error) {
      this.isExpired = true;
      console.log(error);
    }
  }

  async save() {
    try {
      const response = await UserApi.resetPassword(this.token, this.form);
      if (response.meta.status == 200) {
        (this.$refs.resetPasswordCompleted as ResetPasswordCompleted).show();
      } else {
        this.errors = response.meta.errors;
      }
    } catch (error) {
      console.log(error);
    }
  }
}
